import React from 'react';
function AlertHeader({ children }) { return /*#__PURE__*/ React.createElement("header", { className: "alert__header" }, /*#__PURE__*/ React.createElement("h4", { className: "alert__title" }, children)); }
export default AlertHeader;
